<template>
    <div class="">
        <!--Actual select-->

        <select :name="name" class="d-none" v-bind:class="[extra_class ? ' ' + extra_class : '', disabled ? 'disabled' : '']" v-bind:disabled="disabled">
            <option value="-" disabled v-bind:selected="!pre_selected">{{no_selection_name}}</option>
            <option v-for="option in all_options" v-bind:selected="pre_selected === option.value" :value="option.value">{{option.label}}</option>
        </select>

        <!--Custom select-->
        <a class="custom-select"
           v-bind:class="[extra_class ? ' ' + extra_class : '', disabled ? 'disabled' : '']"
           v-bind:data-toggle="disabled ? '' : 'collapse'"
           v-bind:href="disabled ? 'javascript:void(0)' : '#select_template_' + _uid"
           role="button"
           aria-expanded="false"
           :aria-controls="'select_template_' + _uid">
            {{selected ? selected.label : no_selection_name}}
        </a>

        <div class="collapse custom-select-list" v-bind:class="[in_line ? 'in-line' : '', fixed ? 'position-fixed' : '']" :id="'select_template_' + _uid">
            <div class="container justify-content-center">
                <div class="row">
                    <div v-if="prepend_selection" class="col-12">
                        <div v-on:click="select(prepend_selection, $event)" class="item">
                            {{prepend_selection.label}}
                        </div>
                        <hr />
                    </div>
                    <div
                        v-if="all_options.length"
                        v-for="option in options"
                        v-on:click="select(option, $event)"
                        class="item"
                        v-bind:class="in_line ? 'col-12' : 'col-4'"
                    >
                        <span>{{option.label}}</span>
                    </div>
                    <h5 v-if="!all_options.length">{{empty_message || 'No results'}}</h5>
                    <div v-if="create_url" class="col-12">
                        <hr />
                        <div v-on:click="goToCreate()" class="item">
                            Create New
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    	props:[
    		'empty_message',
            'options',
            'pre_selected',
            'name',
            'no_selection_name',
            'extra_class',
            'in_line',
            'prepend_selection',
            'disabled',
            'fixed',
            'create_url'
        ],

        data(){
    		return {
				selected: null,
				all_options: []
            }
        },

        beforeMount() {
    		if (this.options){
				this.all_options = $.extend([], this.options, true);
			}
			else {
    			this.all_options = [];
            }

    		if (this.prepend_selection && this.all_options.length){
				this.all_options.unshift(this.prepend_selection);
            }
        },

        mounted() {
    		let _this = this;

    		if (_this.pre_selected){
    			for (let i=0; i < _this.all_options.length; i++){
    				if (_this.all_options[i].value === _this.pre_selected){
    					_this.selected = _this.all_options[i];
    					break;
                    }
                }
            }

            //If you click outside, should collapse
            $(document).click(function (e){
            	if ($(e.target).parents('#select_template_' + _this._uid).length <= 0){
            		$('#select_template_' + _this._uid).collapse('hide');
                }
            });
        },

        methods: {
			select(option, event) {
				let _this = this;
				if (event != null)	event.preventDefault();

				_this.selected = option;
				$('#select_template_' + _this._uid).collapse('hide');

				_this.$emit('selected', option);
			},

			goToCreate(){
				window.location.href = this.create_url;
            }
		},

        watch: {
    		options(){
				if (this.options){
					this.all_options = this.options;
				}
				else {
					this.all_options = [];
				}

				if (this.prepend_selection && this.all_options.length){
					this.all_options.unshift(this.prepend_selection);
				}

				this.selected = null;
				if (this.pre_selected){
					for (let i=0; i < this.all_options.length; i++){
						if (this.all_options[i].value === this.pre_selected){
							this.selected = this.all_options[i];
							break;
						}
					}
				}
            },
        }
    }
</script>
